export default "__VITE_ASSET__DrSv3$gA__"